<tr>
  <td>
    <div class="dropdown">
      <div class="btn dropdown-toggle" data-bs-toggle="dropdown">
        {{ 'admin.actions.action' | translate }}
      </div>
      <div class="dropdown-menu">
        @if (readOnly) {
          <div class="dropdown-item cursor-pointer" (click)="showDetails()">
            {{ 'admin.actions.details' | translate }}
          </div>
        } @else {
          <div class="dropdown-item cursor-pointer"
            (click)="editUser()"
            [class.disabled]="isLoggedInUser || deletionPending"
            >
            {{ 'admin.actions.edit' | translate }}
          </div>
        }
        <a class="dropdown-item" [routerLink]="[user.id, 'organisations']">
          {{ 'admin.actions.viewOrganisations' | translate }}
        </a>
        <a class="dropdown-item" [routerLink]="[user.id, 'roles']">
          {{ 'admin.actions.viewRoles' | translate }}
        </a>
        @if (!readOnly && !deletionPending) {
          <div class="dropdown-item cursor-pointer"
            (click)="toggleUserActiveStatus()"
            >
            {{ (user.isActive
            ? 'admin.actions.deactivate'
            : 'admin.actions.reactivate') | translate }}
          </div>
          @if (!user.isExternal) {
            <button [class.disabled]="isLoggedInUser" class="dropdown-item" (click)="resendInvite()">
              {{ 'admin.actions.resendInvite' | translate }}
            </button>
          }
        }
        @if (!readOnly && !user.isActive) {
          <button
            class="dropdown-item text-danger"
            [class.disabled]="isLoggedInUser"
            (click)="deleteUser()">
            {{ (deletionPending
            ? 'admin.actions.retryDelete'
            : 'admin.actions.delete') | translate }}
          </button>
        }

        @if (!readOnly && hasImpersonatorRole && impersonationRequested && !isLoggedInUser) {
          <button
            class="dropdown-item"
            (click)="impersonateUser()">
            {{ 'admin.actions.impersonate' | translate }}
          </button>
        }
      </div>

    </div>
  </td>
  @if (hasImpersonatorRole) {
    <td class="text-center">
      @if (impersonationRequested) {
        <i class="fa-light fa-user-headset text-warning"
          [ngbTooltip]="'admin.impersonationRequested' | translate: {impersonationExpiry: user.impersonationExpiry | localisedDate: 'medium'  }">
        </i>
      }
    </td>
  }
  <td class="text-center">
    @if (isAdminUser) {
      <i class="fa-light fa-crown text-warning"
        [ngbTooltip]="'admin.adminUser' | translate">
      </i>
    }
  </td>
  <td>
    <ngb-highlight [result]="user.firstName" [term]="searchTerm"></ngb-highlight>
    @if (user.isTeamMember) {
      <i class="fa-light fa-user-tie text-info ms-2"
        [ngbTooltip]="'admin.teamMember' | translate">
      </i>
    }
  </td>
  <td><ngb-highlight [result]="user.surname" [term]="searchTerm"></ngb-highlight></td>
  <td><ngb-highlight [result]="user.emailAddress ? user.emailAddress : user.name" [term]="searchTerm"></ngb-highlight></td>
  <td>
    @if (user.lastLogin) {
      <span>{{ user.lastLogin | localisedDate: 'short'  }}</span>
    }
    @if (!user.lastLogin) {
      <span>&mdash;</span>
    }
  </td>
  <td>
    @if (user.isActive) {
      <span class="badge bg-success-lt">{{ 'admin.status.active' | translate }}</span>
    }
    @if (deletionPending) {
      <span class="badge bg-warning-lt"
        [ngbTooltip]="'admin.status.deletionPendingTooltip' | translate">
        {{ 'admin.status.deletionPending' | translate }}
      </span>
    } @else if (!user.isActive) {
      <span class="badge bg-danger-lt">
        {{ 'admin.status.inactive' | translate }}
        @if (user.deactivationDate) {
          <span>{{ user.deactivationDate | localisedDate }}</span>
        }
      </span>
    }
  </td>
  <td>
    @if (!user.organisations) {
      <span>&mdash;</span>
    }
    @if (user.organisations.length > 0) {
      <span>
        {{ user.organisations[0].name }}
        @if (user.organisations.length > 1) {
          <a class="ms-2" [routerLink]="[user.id, 'organisations']" >
            <span class="badge bg-primary-lt">+{{ user.organisations.length - 1}}</span>
          </a>
        }
      </span>
    }
  </td>
</tr>